(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-pairs-well-with"] && !Shopify.designMode) return;
  try {
    class ProductPairs extends HTMLElement {
    connectedCallback() {
      if (!this.dataset.url) return;
      this.observer = new IntersectionObserver(
        (entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.observer.disconnect();
          this.load();
        },
        { rootMargin: '0px 0px 400px 0px' }
      );
      this.observer.observe(this.parentElement || this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    async load() {
      try {
        const response = await fetch(this.dataset.url);
        if (!response.ok) return;
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const content = html.getElementById(this.dataset.target)?.querySelector('[data-pairs-content]');
        if (content) this.replaceWith(document.importNode(content, true));
      } catch {}
    }
  }

  if (!customElements.get('product-pairs')) customElements.define('product-pairs', ProductPairs);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-share"] && !Shopify.designMode) return;
  try {
    class ProductShare extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-share-button]');
      this.status = this.querySelector('[data-share-status]');
      if (!this.button || (!navigator.share && !navigator.clipboard)) return;
      this.button.hidden = false;
      this.onClick = this.onClick.bind(this);
      this.button.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.onClick);
      clearTimeout(this.statusTimer);
    }

    async onClick() {
      const { url, title } = this.dataset;
      if (navigator.share) {
        try {
          await navigator.share({ url, title });
          return;
        } catch (error) {
          if (error.name === 'AbortError') return;
        }
      }
      try {
        await navigator.clipboard.writeText(url);
        this.showStatus(this.querySelector('[data-share-copied]')?.content.textContent.trim() || '');
      } catch {
        this.showStatus(url);
      }
    }

    showStatus(message) {
      this.status.textContent = message;
      clearTimeout(this.statusTimer);
      this.statusTimer = setTimeout(() => {
        this.status.textContent = '';
      }, 4000);
    }
  }

  if (!customElements.get('product-share')) customElements.define('product-share', ProductShare);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-variant-picker"] && !Shopify.designMode) return;
  try {
    class VariantPicker extends HTMLElement {
    connectedCallback() {
      this.variants = this.readVariants();
      this.chosen = new Set(
        this.fieldsets
          .filter((fieldset) => !this.hasAttribute('data-require-selection') || fieldset.hasAttribute('data-single'))
          .map((fieldset) => this.position(fieldset))
      );
      this.abortController = new AbortController();
      const { signal } = this.abortController;
      this.addEventListener('change', (event) => this.onChange(event), { signal });
      this.addEventListener('click', (event) => this.onClick(event), { signal });
      this.addEventListener('keydown', (event) => this.onKeydown(event), { signal });
      document.addEventListener('click', (event) => this.onDocumentClick(event), { signal });
      this.refresh();
    }

    disconnectedCallback() {
      this.abortController?.abort();
      clearTimeout(this.warningTimer);
    }

    readVariants() {
      try {
        return JSON.parse(this.querySelector('[data-variant-data]')?.textContent || '[]');
      } catch {
        return [];
      }
    }

    get fieldsets() {
      return [...this.querySelectorAll('[data-option]')];
    }

    get isPending() {
      return this.fieldsets.some((fieldset) => !this.chosen.has(this.position(fieldset)));
    }

    position(fieldset) {
      return Number(fieldset.dataset.optionPosition);
    }

    selections() {
      const selections = new Map();
      this.fieldsets.forEach((fieldset) => {
        const position = this.position(fieldset);
        const value = fieldset.querySelector('.variant-picker__input:checked')?.value;
        if (this.chosen.has(position) && value !== undefined) selections.set(position, value);
      });
      return selections;
    }

    candidates(position, value, selections) {
      return this.variants.filter((variant) => {
        if (variant.options[position - 1] !== value) return false;
        for (const [otherPosition, otherValue] of selections) {
          if (otherPosition !== position && variant.options[otherPosition - 1] !== otherValue) return false;
        }
        return true;
      });
    }

    onChange(event) {
      const native = event.target.closest('[data-native-option]');
      if (native) return this.onNativeChange(native);
      const input = event.target.closest('[data-option-value-id]');
      if (!input) return;
      this.chosen.add(this.position(input.closest('[data-option]')));
      this.closeMenus();
      this.hideWarnings();
    }

    onNativeChange(select) {
      const fieldset = select.closest('[data-option]');
      if (!fieldset) return;
      if (select.value === '') return this.resetOption(fieldset);
      const input = [...fieldset.querySelectorAll('.variant-picker__input')].find((item) => item.value === select.value);
      if (!input) return;
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    resetOption(fieldset) {
      if (!fieldset.hasAttribute('data-single')) this.chosen.delete(this.position(fieldset));
      this.closeMenus();
      this.refresh();
    }

    onClick(event) {
      const trigger = event.target.closest('[data-dropdown-trigger]');
      if (trigger) return this.toggleMenu(trigger);

      const reset = event.target.closest('[data-option-reset]');
      if (reset) {
        const fieldset = reset.closest('[data-option]');
        this.resetOption(fieldset);
        fieldset.querySelector('[data-dropdown-trigger]')?.focus();
        return;
      }

      if (event.target.closest('.variant-dropdown__item')) {
        requestAnimationFrame(() => this.closeMenus());
        return;
      }

      const chip = event.target.closest('[data-value-chip]');
      if (chip) return this.requestNotify(chip.closest('[data-option]'), chip.dataset.value);

      const notifyFirst = event.target.closest('[data-notify-first]');
      if (notifyFirst) {
        const fieldset = notifyFirst.closest('[data-option]');
        const firstChip = fieldset.querySelector('[data-value-chip]:not([hidden])');
        if (firstChip) this.requestNotify(fieldset, firstChip.dataset.value);
        return;
      }

      const unavailableLabel = event.target.closest('.variant-swatch[data-unavailable] label');
      if (unavailableLabel) {
        event.preventDefault();
        const item = unavailableLabel.closest('[data-value-item]');
        this.requestNotify(item.closest('[data-option]'), item.dataset.value);
      }
    }

    onKeydown(event) {
      if (event.key !== 'Escape') return;
      const menu = event.target.closest('[data-dropdown-menu]');
      if (!menu) return;
      event.stopPropagation();
      this.closeMenus();
      menu.closest('[data-option]')?.querySelector('[data-dropdown-trigger]')?.focus();
    }

    onDocumentClick(event) {
      if (!event.target.closest('.variant-dropdown')) this.closeMenus();
    }

    toggleMenu(trigger) {
      const willOpen = trigger.getAttribute('aria-expanded') !== 'true';
      this.closeMenus();
      if (!willOpen) return;
      const menu = document.getElementById(trigger.getAttribute('aria-controls'));
      if (!menu) return;
      trigger.setAttribute('aria-expanded', 'true');
      menu.hidden = false;
      const fieldset = trigger.closest('[data-option]');
      const checked = fieldset.hasAttribute('data-chosen')
        ? menu.querySelector('[data-value-item]:not([hidden]) .variant-picker__input:checked')
        : null;
      (checked || menu.querySelector('[data-value-item]:not([hidden]) .variant-picker__input'))?.focus({
        preventScroll: true,
      });
    }

    closeMenus() {
      this.querySelectorAll('[data-dropdown-trigger][aria-expanded="true"]').forEach((trigger) => {
        trigger.setAttribute('aria-expanded', 'false');
        const menu = document.getElementById(trigger.getAttribute('aria-controls'));
        if (menu) menu.hidden = true;
      });
    }

    hideWarnings() {
      this.querySelectorAll('[data-option-warning]').forEach((warning) => {
        warning.hidden = true;
      });
    }

    warn(fieldset) {
      this.hideWarnings();
      const warning = fieldset.querySelector('[data-option-warning]');
      if (!warning) return;
      warning.hidden = false;
      fieldset.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      clearTimeout(this.warningTimer);
      this.warningTimer = setTimeout(() => {
        warning.hidden = true;
      }, 4000);
    }

    warnFirstMissing() {
      const missing = this.fieldsets.find((fieldset) => !this.chosen.has(this.position(fieldset)));
      if (missing) this.warn(missing);
      return Boolean(missing);
    }

    requestNotify(fieldset, value) {
      const position = this.position(fieldset);
      const missing = this.fieldsets.find(
        (other) => other !== fieldset && !this.chosen.has(this.position(other))
      );
      if (missing) return this.warn(missing);
      const [variant] = this.candidates(position, value, this.selections());
      if (!variant) return;
      this.closeMenus();
      this.dispatchEvent(
        new CustomEvent('product:notify', { bubbles: true, detail: { id: variant.id, title: variant.title } })
      );
    }

    stockText(variant) {
      if (!variant) return '';
      if (!variant.available) return this.dataset.soldOutText || '';
      const threshold = Number(this.dataset.lowStockThreshold || 0);
      if (variant.qty !== null && variant.qty > 0 && variant.qty <= threshold) {
        return (this.dataset.lowStockText || '').replace('[count]', variant.qty);
      }
      return '';
    }

    syncNative(fieldset, isChosen, availability, notes) {
      const select = fieldset.querySelector('[data-native-option]');
      if (!select) return;
      const soldOutText = this.dataset.soldOutText || '';
      [...select.options].forEach((option) => {
        if (!option.value) return;
        const isAvailable = availability.get(option.value) ?? false;
        const suffix = isAvailable ? notes.get(option.value) : soldOutText;
        option.disabled = !isAvailable;
        option.textContent = suffix ? `${option.value} — ${suffix}` : option.value;
      });
      const checked = fieldset.querySelector('.variant-picker__input:checked')?.value;
      select.value = isChosen && checked !== undefined ? checked : '';
    }

    refresh() {
      const selections = this.selections();
      this.fieldsets.forEach((fieldset) => {
        const position = this.position(fieldset);
        const isChosen = this.chosen.has(position);
        const othersChosen = this.fieldsets.every((other) => other === fieldset || this.chosen.has(this.position(other)));
        fieldset.toggleAttribute('data-chosen', isChosen);

        const availability = new Map();
        const notes = new Map();
        fieldset.querySelectorAll('[data-value-item]').forEach((item) => {
          const candidates = this.candidates(position, item.dataset.value, selections);
          const isAvailable = candidates.some((variant) => variant.available);
          availability.set(item.dataset.value, isAvailable);
          item.toggleAttribute('data-unavailable', !isAvailable);
          if (item.classList.contains('variant-dropdown__row')) item.hidden = !isAvailable;

          const variant = othersChosen ? candidates[0] : null;
          const text = this.stockText(variant);
          notes.set(item.dataset.value, text);
          const note = item.querySelector('[data-stock-note]');
          if (!note) return;
          note.textContent = text;
          note.hidden = !text;
          note.dataset.status = variant && !variant.available ? 'sold-out' : 'low';
        });
        this.syncNative(fieldset, isChosen, availability, notes);

        let unavailableCount = 0;
        fieldset.querySelectorAll('[data-value-chip]').forEach((chip) => {
          const isAvailable = availability.get(chip.dataset.value) ?? false;
          chip.hidden = isAvailable;
          if (!isAvailable) unavailableCount += 1;
        });
        const group = fieldset.querySelector('[data-soldout-group]');
        if (group) group.hidden = unavailableCount === 0;
      });

      this.closest('product-info')?.setPending?.(this.isPending);
    }
  }

  if (!customElements.get('variant-picker')) customElements.define('variant-picker', VariantPicker);
  } catch(e) { console.error(e); }
})();

})();
